import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { useQuickViewCategory } from './hooks/useQuickViewCategory';

import dibsCss from 'dibs-css';
import classnames from 'classnames';

import { type QuickViewCategory_item$key } from './__generated__/QuickViewCategory_item.graphql';
import { type QuickViewCategory_itemSearch$key } from './__generated__/QuickViewCategory_itemSearch.graphql';

const itemSearchFragment = graphql`
    fragment QuickViewCategory_itemSearch on ItemSearchQueryConnection {
        ...useQuickViewCategory_itemSearch
    }
`;
const itemFragment = graphql`
    fragment QuickViewCategory_item on Item {
        quickViewDisplay {
            paragraphAttributeNames {
                ...useQuickViewCategory_quickViewCategorySegments
            }
        }
    }
`;

type Props = {
    itemSearch: QuickViewCategory_itemSearch$key | null | undefined;
    item: QuickViewCategory_item$key;
    attributes: string | null;
    isSmall: boolean;
};

export const QuickViewCategory: FC<Props> = ({
    itemSearch: itemSearchRef,
    item: itemRef,
    attributes,
    isSmall,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const item = useFragment(itemFragment, itemRef);
    const paragraphAttributeNames = item?.quickViewDisplay?.paragraphAttributeNames;

    const category = useQuickViewCategory({
        itemSearch,
        paragraphAttributeNames,
    });

    if (!category && !attributes) {
        return null;
    }

    return (
        <div data-tn="quick-view-category">
            <span
                className={
                    isSmall ? dibsCss.sassyFontBodyXSmallHeavy : dibsCss.sassyFontBodySmallHeavy
                }
            >
                <FormattedMessage
                    id="dibs-buyer-product-tile.QuickViewCategory.category"
                    defaultMessage="Category"
                />
            </span>
            <HeadingLevel>
                {Heading => (
                    <Heading
                        dataTn="quick-view-category-text"
                        className={classnames(
                            isSmall ? dibsCss.sassyFontBodyXSmall : dibsCss.sassyFontBodySmall,
                            dibsCss.m0
                        )}
                    >
                        {category || attributes}
                    </Heading>
                )}
            </HeadingLevel>
        </div>
    );
};
